import React, { useState, useMemo } from "react";
import {
  SvgMenuExpenses,
  SvgAmount,
  FormationsItems,
  SvgBlackTrash, SvgUpdateAssignationIcon
} from "@routes/IconeSvg";
import moment from "moment-timezone";
import SharedViewFile from "@components/modals/SharedViewFile";
import BlackTooltip from "@components/tooltip/BlackTooltip";
import {
  getDateToRender
} from "@helpers/_functions";
import ModalDelete from "../components/modals/DeleteFormation";
import { Menu } from "@components/tailwindComponents";
import useFormation from "../hooksFormation";
import file_carrer from "@assets/image/icones/carrer/file_carrer.svg";

export default function Items({
  formation,
  t,
  i18n,
  key,
  toggleModalFormationForm,
  readOnly,
  isOnMyProfile = false
}) {
  const [showDelete, setShowDelete] = useState(false);
  const [sharedViewFile, setShowFile] = useState(false);
  const [file, setFile] = useState({});

  const { deleteFormation } = useFormation();

  const onClickDelete = () => {
    setShowDelete(!showDelete);
  };
  const onClickShowFile = (file) => {
    setShowFile(!sharedViewFile);
    setFile(file);
  };

  const listsMenu = [
    {
      icon: <SvgBlackTrash />,
      title: t("Effacer"),
      click: () => onClickDelete()
    },
    {
      icon: <SvgUpdateAssignationIcon />,
      title: t("Modifier"),
      click: () => toggleModalFormationForm(formation)
    }
  ]

  const periodFormation = moment(getDateToRender(formation.startDate))
    .locale(i18n.language)
    .format("LL"
    )
    + (moment(getDateToRender(formation.endDate)).isValid()
      ? ` - ${moment(getDateToRender(formation.endDate))
        .locale(i18n.language)
        .format("LL"
        )}`
      : "");

  const devise = formation.devise || "$ ";

  const getCostDetail = (formation) => {
    const costTrainer = parseFloat(formation.costTrainer) || 0;
    const costSalary = parseFloat(formation.costSalary) || 0;
    const costTravel = parseFloat(formation.costTravel) || 0;
    const costOthers = parseFloat(formation.costOthers) || 0;
    return { costTrainer, costSalary, costTravel, costOthers };
  };

  const costTotal = useMemo(() => {
    const { costTrainer, costSalary, costTravel, costOthers } = getCostDetail(formation);
    return (costTrainer + costSalary + costTravel + costOthers).toFixed(2);
  }, [
    formation.costTrainer,
    formation.costSalary,
    formation.costOthers,
    formation.costTravel
  ])

  const TooltipCostDetail = () => {
    const { costTrainer, costSalary, costTravel, costOthers } = getCostDetail(formation);
    return (
      <div className="arh-w-full">
        <div className="arh-flex arh-flex-col arh-space-y-2 arh-bg-transparent">
          <span className="arh-whitespace-pre-wrap arh-font-medium arh-text-[11px]  arh-text-white">
            {t("Coût salaire")} : {devise} {costSalary.toFixed(2)} <br />
            {t("Coût formateur")} : {devise} {costTrainer.toFixed(2)} <br />
            {t("Coût voyage")} : {devise} {costTravel.toFixed(2)} <br />
            {t("Autes coûts")} : {devise} {costOthers.toFixed(2)} <br />
            {"Total"} : {devise} {costTotal}
          </span>
        </div>
      </div>
    )
  }

  const handleDeleteFormation = () => {
    deleteFormation(formation?._id, () => {
      onClickDelete();
    })
  }

  return (
    <>
      <tr
        className="arh-border-b arh-border-x-0 arh-border-t-0 arh-border-solid arh-border-borderTable hover:arh-bg-greyColor"
        key={key}
      >
        <td className="arh-px-4 arh-py-3 ">
          <BlackTooltip
            title={
              <p
                className="arh-m-0 arh-w-full"
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 5,
                  fontSize: "12px"
                }}
              >
                {formation.title}
              </p>
            }
            placement="top"
          >
            <div className="arh-max-w-full arh-flex arh-items-center arh-space-x-2.5">
              {FormationsItems()}
              <p className="arh-mb-0 arh-w-full arh-shrink arh-truncate desktop-middle:arh-w-24 arh-max-w-[12rem] arh-font-medium arh-text-xs arh-text-darkGreyColor arh-max-w-fit">
                {formation.title}
              </p>
            </div>
          </BlackTooltip>
        </td>
        <td className="arh-px-4 arh-py-3 arh-align-middle">
          <BlackTooltip
            title={<p
              className="arh-m-0 arh-w-full"
              style={{
                overflow: "hidden",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 5,
                fontSize: "12px"
              }}
            >
              {formation.category?.name || "-"}
            </p>}
            placement="top"
          >
            <div className="arh-truncate arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor arh-whitespace-nowrap arh-max-w-fit">
              {formation.category?.name || "-"}
            </div>
          </BlackTooltip>
        </td>
        <td className="arh-px-4 arh-py-3 arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor">
          <BlackTooltip
            title={<p
              className="arh-m-0 arh-w-full"
              style={{
                overflow: "hidden",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 5,
                fontSize: "12px"
              }}
            >
              {periodFormation}
            </p>}
            placement="top"
          >
            <div className="arh-truncate arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor arh-whitespace-nowrap arh-max-w-fit">
              {periodFormation}
            </div>
          </BlackTooltip>
        </td>
        <td className="arh-px-4 arh-py-3 arh-align-middle">
          <span className="arh-line-clamp-3 arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor">
            {formation.hour ? `${formation.hour} H` : "-"}
          </span>
        </td>
        <td className="arh-px-4 arh-py-3 arh-align-middle">
          <BlackTooltip
            title={<p
              className="arh-m-0 arh-w-full"
              style={{
                overflow: "hidden",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 5,
                fontSize: "12px"
              }}
            >
              {formation.trainer?.name || "-"}
            </p>}
            placement="top"
          >
            <div className="arh-truncate arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor arh-whitespace-nowrap arh-max-w-fit">
              {formation.trainer?.name || "-"}
            </div>
          </BlackTooltip>
        </td>
        <td className="arh-px-4 arh-py-3 ">
          {
            formation.note?.length > 0 ?
              <BlackTooltip
                title={<p
                  className="arh-m-0 arh-w-full"
                  style={{
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 5,
                    fontSize: "12px"
                  }}
                >
                  {formation.note}
                </p>}
                placement="top"
              >
                <img alt="file_carrer" src={file_carrer} />
              </BlackTooltip>
              : "-"
          }
        </td>
        <td className="arh-px-4 arh-py-3 arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor">
          {formation?.files?.length > 0
            ? formation?.files?.map((file) => (
              <BlackTooltip
                title={file?.filename}
                placement="top"
                key={file?._id}
              >
                <div
                  className="arh-flex arh-items-center arh-justify-start arh-space-x-2 arh-w-full arh-cursor-pointer"
                  onClick={() => onClickShowFile(file)}
                >
                  <span>{SvgMenuExpenses()}</span>
                  <span className="arh-truncate arh-w-full arh-block">
                    {file?.filename}
                  </span>
                </div>
              </BlackTooltip>
            ))
            : "-"}
        </td>
        <td className="arh-px-4 arh-py-3">
          <div className="arh-flex arh-items-center">
            <span className="arh-mr-[6px] arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor arh-truncate">
              {devise} {costTotal}
            </span>
            <BlackTooltip
              title={isOnMyProfile ? "" : <TooltipCostDetail />}
              placement="top"
            >
              <span className="arh-shrink-0">{SvgAmount()}</span>
            </BlackTooltip>
          </div>
        </td>

        <td className="arh-px-4 arh-py-3 ">
          <div className="arh-flex arh-items-center arh-space-x-4">
            <BlackTooltip
              title={<p
                className="arh-m-0 arh-w-full"
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 5,
                  fontSize: "12px"
                }}
              >
                {formation?.elligibility || "-"}
              </p>}
              placement="top"
            >
              <div className="arh-truncate arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor arh-whitespace-nowrap">
                {formation?.elligibility || "-"}
              </div>
            </BlackTooltip>
          </div>
        </td>
        <td className="arh-px-4 arh-py-3 ">
          <div className="arh-flex arh-items-center arh-space-x-4">
            <BlackTooltip
              title={<p
                className="arh-m-0 arh-w-full"
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 5,
                  fontSize: "12px"
                }}
              >
                {formation.status?.name || "-"}
              </p>}
              placement="top"
            >
              <div className="arh-truncate arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor arh-whitespace-nowrap">
                {formation.status?.name || "-"}
              </div>
            </BlackTooltip>
          </div>
        </td>
        <td className="arh-px-4 arh-py-3 ">
          {!readOnly ?
            <Menu
              lists={listsMenu}
              withIcon
            />
            : ""
          }
        </td>
      </tr>
      <ModalDelete
        onClickClose={onClickDelete}
        onDeleteClick={handleDeleteFormation}
        show={showDelete}
        t={t}
      />

      <SharedViewFile
        onClickClose={onClickShowFile}
        show={sharedViewFile}
        file={file}
        t={t}
      />
    </>
  );
}
